import { Entity } from './entity';

export enum FeatureStatus {
  Beta = 'beta',
  Released = 'released',
}

export interface Feature extends Entity {
  name: string;
  description: string;
  status: FeatureStatus;
}
